export const MIN_PASSWORD_LENGTH = 8

export const hasMinimumLength = (password: string): boolean => password.length >= MIN_PASSWORD_LENGTH

export const hasLowercaseLetter = (password: string): boolean => /[a-z]/.test(password)

export const hasUppercaseLetter = (password: string): boolean => /[A-Z]/.test(password)

export const hasNumber = (password: string): boolean => /\d/.test(password)

export const hasSpecialCharacter = (password: string): boolean => /[^A-Za-z0-9]/.test(password)
